module.exports = "<div [hidden]=\"!active\" class=\"fx-full-height\">\n    <ng-content></ng-content>\n</div>"